import { useMeContext } from 'modules/me';

export const useIsSmartSuggestionSettingEnabled = (): boolean => {
  const me = useMeContext();
  const isSmartSuggestionEnabled = me?.isSmartSuggestionEnabled;

  return isSmartSuggestionEnabled ?? false;
};
